import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { StepIndicator } from '../components/StepIndicator';
import { SearchIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Master Creative', 'Campaign Setup', 'Select Creative', 'Styling Template', 'Variable Content', 'Generate', 'Review & Publish'];
const DEALERS = [{
  id: 1,
  name: 'Mumbai Central Motors',
  city: 'Mumbai',
  state: 'Maharashtra',
  zone: 'West'
}, {
  id: 2,
  name: 'Delhi Auto Hub',
  city: 'Delhi',
  state: 'Delhi',
  zone: 'North'
}, {
  id: 3,
  name: 'Bangalore Premium Cars',
  city: 'Bangalore',
  state: 'Karnataka',
  zone: 'South'
}, {
  id: 4,
  name: 'Pune Elite Motors',
  city: 'Pune',
  state: 'Maharashtra',
  zone: 'West'
}, {
  id: 5,
  name: 'Chennai Auto World',
  city: 'Chennai',
  state: 'Tamil Nadu',
  zone: 'South'
}, {
  id: 6,
  name: 'Hyderabad Car Center',
  city: 'Hyderabad',
  state: 'Telangana',
  zone: 'South'
}, {
  id: 7,
  name: 'Kolkata Motors',
  city: 'Kolkata',
  state: 'West Bengal',
  zone: 'East'
}, {
  id: 8,
  name: 'Ahmedabad Auto Plaza',
  city: 'Ahmedabad',
  state: 'Gujarat',
  zone: 'West'
}];
export function CampaignSetup() {
  const navigate = useNavigate();
  const [selectedDealers, setSelectedDealers] = useState<number[]>([]);
  const [filterZone, setFilterZone] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [budget, setBudget] = useState('');
  const toggleDealer = (dealerId: number) => {
    setSelectedDealers(prev => prev.includes(dealerId) ? prev.filter(id => id !== dealerId) : [...prev, dealerId]);
  };
  const selectAll = () => {
    setSelectedDealers(filteredDealers.map(d => d.id));
  };
  const clearAll = () => {
    setSelectedDealers([]);
  };
  const filteredDealers = DEALERS.filter(dealer => {
    const matchesZone = filterZone === 'all' || dealer.zone === filterZone;
    const matchesSearch = dealer.name.toLowerCase().includes(searchQuery.toLowerCase()) || dealer.city.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesZone && matchesSearch;
  });
  const canContinue = selectedDealers.length > 0 && startDate && endDate && budget;
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-881">
      <Sidebar data-id="element-882" />
      <main className="flex-1" data-id="element-883">
        <Header data-id="element-884" />
        <StepIndicator currentStep={2} steps={STEPS} data-id="element-885" />
        <div className="px-6 py-8" data-id="element-886">
          <div className="max-w-5xl mx-auto" data-id="element-887">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-888">
              Step 1: Campaign Setup
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-889">
              Select dealers and set campaign parameters
            </p>

            <div className="grid grid-cols-3 gap-6" data-id="element-890">
              <div className="col-span-2 space-y-6" data-id="element-891">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-892">
                  <div className="flex items-center justify-between mb-4" data-id="element-893">
                    <h3 className="font-medium text-gray-800" data-id="element-894">
                      Select Dealers
                    </h3>
                    <div className="flex space-x-2" data-id="element-895">
                      <button onClick={selectAll} className="text-sm text-blue-500 hover:text-blue-600" data-id="element-896">
                        Select All
                      </button>
                      <span className="text-gray-300" data-id="element-897">|</span>
                      <button onClick={clearAll} className="text-sm text-gray-500 hover:text-gray-600" data-id="element-898">
                        Clear All
                      </button>
                    </div>
                  </div>

                  <div className="flex space-x-3 mb-4" data-id="element-899">
                    <div className="relative flex-1" data-id="element-900">
                      <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-901" />
                      <input type="text" placeholder="Search dealers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm" data-id="element-902" />
                    </div>
                    <select value={filterZone} onChange={e => setFilterZone(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-md text-sm" data-id="element-903">
                      <option value="all" data-id="element-904">All Zones</option>
                      <option value="North" data-id="element-905">North</option>
                      <option value="South" data-id="element-906">South</option>
                      <option value="East" data-id="element-907">East</option>
                      <option value="West" data-id="element-908">West</option>
                    </select>
                  </div>

                  <div className="space-y-2 max-h-96 overflow-y-auto" data-id="element-909">
                    {filteredDealers.map(dealer => <label key={dealer.id} className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer" data-id="element-910">
                        <input type="checkbox" checked={selectedDealers.includes(dealer.id)} onChange={() => toggleDealer(dealer.id)} className="mr-3 w-4 h-4 text-blue-500" data-id="element-911" />
                        <div className="flex-1" data-id="element-912">
                          <p className="font-medium text-gray-800" data-id="element-913">
                            {dealer.name}
                          </p>
                          <div className="flex items-center text-sm text-gray-500 mt-1" data-id="element-914">
                            <MapPinIcon size={14} className="mr-1" data-id="element-915" />
                            {dealer.city}, {dealer.state} • {dealer.zone} Zone
                          </div>
                        </div>
                      </label>)}
                  </div>
                </div>
              </div>

              <div className="space-y-6" data-id="element-916">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-917">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-918">
                    Campaign Parameters
                  </h3>
                  <div className="space-y-4" data-id="element-919">
                    <div data-id="element-920">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-921">
                        Start Date
                      </label>
                      <div className="relative" data-id="element-922">
                        <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-923" />
                        <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm" data-id="element-924" />
                      </div>
                    </div>

                    <div data-id="element-925">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-926">
                        End Date
                      </label>
                      <div className="relative" data-id="element-927">
                        <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-928" />
                        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm" data-id="element-929" />
                      </div>
                    </div>

                    <div data-id="element-930">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-931">
                        Total Budget (₹)
                      </label>
                      <input type="number" value={budget} onChange={e => setBudget(e.target.value)} placeholder="Enter budget" className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm" data-id="element-932" />
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-933">
                  <h4 className="font-medium text-blue-900 mb-2" data-id="element-934">Summary</h4>
                  <div className="text-sm text-blue-800 space-y-1" data-id="element-935">
                    <p data-id="element-936">
                      <strong data-id="element-937">{selectedDealers.length}</strong> dealers selected
                    </p>
                    {budget && <p data-id="element-938">
                        <strong data-id="element-939">₹{budget}</strong> total budget
                      </p>}
                    {startDate && endDate && <p data-id="element-940">
                        Duration: <strong data-id="element-941">{startDate}</strong> to{' '}
                        <strong data-id="element-942">{endDate}</strong>
                      </p>}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-6" data-id="element-943">
              <button onClick={() => navigate('/dealerization/step-0')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-944">
                Back
              </button>
              <button onClick={() => navigate('/dealerization/step-2')} disabled={!canContinue} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-945">
                Continue to Creative Selection
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}